import React from 'react'
import { useForm, SubmitHandler } from 'react-hook-form'
import { useNavigate, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { client } from '../../utils/api-client'
import { Helmet } from 'react-helmet-async'

interface IFormInput {
  newPassword: number | string
  newPasswordConfirmation: number | string
}

export const ResetPasswordForm = () => {
  const [show, setShow] = React.useState(false)
  const [showPassword, setShowPassword] = React.useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const resetCode = location.state.resetCode
  const {
    register,
    handleSubmit,
    setFocus,
    formState: { errors },
  } = useForm<IFormInput>()
  const onSubmit: SubmitHandler<IFormInput> = async (options) => {
    let data = {
      resetCode,
      newPassword: options.newPassword,
      newPasswordConfirmation: options.newPasswordConfirmation,
    }
    const result = await client('user/reset-password', { data })
    if (result) setShow(true)
  }

  const handleGoToLoginPageClick = () => {
    navigate('/login', { replace: true })
  }

  const handleShowPasswordClick = (e: any) => {
    e.preventDefault()
    setShowPassword(!showPassword)
  }

  const handleShowConfirmPasswordClick = (e: any) => {
    e.preventDefault()
    setShowConfirmPassword(!showConfirmPassword)
  }

  React.useEffect(() => {
    setFocus('newPassword')
  }, [setFocus])

  return (
    <div
      className='max-w-lg mt-5 mx-auto flex flex-col my-12 h-auto border py-8 px-4 rounded-md'
      style={{
        backgroundColor: 'var(--card-bg)',
        color: 'var(--text-primary)',
        borderColor: 'var(--border-color)',
      }}
    >
      <Helmet>
        <title className='text-xl font-semibold'>تغییر پسورد</title>
        <meta
          name='description'
          content='بوک استوری - هر کتاب یک داستان، هر داستان یک زندگی دوباره'
        />
      </Helmet>
      <div className={show ? 'block' : 'hidden'}>
        <h2 className='text-lg text-start font-medium '>
          رمز عبور شما با موفقیت تغییر کرد.
        </h2>
        <button
          className='w-full rounded text-white uppercase border-none mt-8 sm:mt-10 py-3 sm:py-4 px-4 text-base sm:text-lg font-medium active:transition-all active:duration-[0.3s] active:opacity-80 cursor-pointer'
          style={{ backgroundColor: 'var(--accent-primary)' }}
          onClick={handleGoToLoginPageClick}
        >
          تایید
        </button>
      </div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={!show ? 'block' : 'hidden'}
      >
        <h1 className='text-lg text-start font-medium mt-4 mb-2'>
          لطفا رمز جدید خود را وارد کنید:
        </h1>
        <div className='relative'>
          <input
            className='input-theme block outline-none w-full rounded border p-4 pr-12 mb-2.5 text-base sm:text-lg'
            type={showPassword ? 'text' : 'password'}
            {...register('newPassword', {
              required: 'new password is required',
              minLength: { value: 8, message: 'Min length is 8' },
            })}
            dir='ltr'
          />
          <button
            type='button'
            className='absolute top-1/2 right-3 -translate-y-1/2 transform'
            onClick={handleShowPasswordClick}
            aria-label='نمایش یا پنهان کردن رمز'
          >
            {showPassword ? (
              <FontAwesomeIcon
                icon={faEyeSlash}
                style={{
                  fontSize: 16,
                  marginLeft: 12,
                  color: 'var(--text-primary)',
                }}
              />
            ) : (
              <FontAwesomeIcon
                icon={faEye}
                style={{
                  fontSize: 16,
                  marginLeft: 12,
                  color: 'var(--text-primary)',
                }}
              />
            )}
          </button>
          {errors.newPassword && (
            <p className='text-red-600 before:inline before:content-["⚠"]'>
              {' '}
              {errors.newPassword.message}
            </p>
          )}
          {/* <h6
            className='absolute top-1.5 right-1.5'
            onClick={handleShowPasswordClick}
          >
            {showPassword ? 'hide' : 'show'}
          </h6> */}
        </div>
        <h1 className='text-lg text-start font-medium mt-4 mb-2'>
          لطفا رمز جدید خود را دوباره وارد کنید:
        </h1>
        <div className='relative'>
          <input
            className='input-theme block outline-none w-full rounded border p-4 pr-12 mb-2.5 text-base sm:text-lg'
            type={showConfirmPassword ? 'text' : 'password'}
            {...register('newPasswordConfirmation', {
              required: 'new password confirmation is required',
              minLength: { value: 8, message: 'Min length is 8' },
            })}
            dir='ltr'
          />
          <button
            type='button'
            className='absolute top-1/2 right-3 -translate-y-1/2 transform'
            onClick={handleShowConfirmPasswordClick}
            aria-label='نمایش یا پنهان کردن تکرار رمز'
          >
            {showConfirmPassword ? (
              <FontAwesomeIcon
                icon={faEyeSlash}
                style={{ fontSize: 16, marginLeft: 12, color: 'black' }}
              />
            ) : (
              <FontAwesomeIcon
                icon={faEye}
                style={{ fontSize: 16, marginLeft: 12, color: 'black' }}
              />
            )}
          </button>
          {errors.newPasswordConfirmation && (
            <p className='text-red-600 before:inline before:content-["⚠"]'>
              {' '}
              {errors.newPasswordConfirmation.message}
            </p>
          )}
          {/* <h6
            className='absolute top-1.5 right-1.5'
            onClick={handleShowConfirmPasswordClick}
          >
            {showConfirmPassword ? 'hide' : 'show'}
          </h6> */}
        </div>
        <input
          className='w-full rounded text-white uppercase border-none mt-8 sm:mt-10 py-3 sm:py-4 px-4 text-base sm:text-lg font-medium active:transition-all active:duration-[0.3s] active:opacity-80 cursor-pointer'
          style={{ backgroundColor: 'var(--accent-primary)' }}
          type='submit'
          value='تایید'
        />
      </form>
    </div>
  )
}
